export const translationDomain = 'common:billing.invoices.billing-notifications';
